import { Button } from '@ksyos/design-system';
import { translateKey } from '../../translate';

interface IRightButtonsProps {
    currentStep: number;
    isDisabled: boolean;
    nextStepLabel?: string;
    onClickNextStep: () => void;
    onClickPreviousStep: () => void;
}

export function RightButtons(props: IRightButtonsProps) {
    return (
        <>
            {props.currentStep > 0 && (
                <Button
                    onClick={props.onClickPreviousStep}
                    variant={'outline'}
                >
                    {translateKey('common.previousStep')}
                </Button>
            )}
            <Button
                isDisabled={props.isDisabled}
                onClick={props.onClickNextStep}
            >
                {props.nextStepLabel ? props.nextStepLabel : translateKey('common.nextStep')}
            </Button>
        </>
    );
}
